import { IdmissionIDValidationMobile } from './IdmissionIDValidationMobile';

export default function VerifyIDScreen() {
  return <IdmissionIDValidationMobile />;
}
